// Project Configuration
// Centralized configuration for all portfolio projects

export const projectsConfig = [
  {
    id: 2,
    title: '4 Prosper Technologies',
    category: 'Corporate Website',
    role: 'Designer & Developer',
    description: 'Corporate website redesign for a B2B service company. Focused on improving visual structure, navigation clarity, and responsive layout for better user engagement.',
    tech: ['React', 'Figma', 'CSS3'],
    metric: 'Delivered',
    folder: '4-prosper-technologies',
    imageCount: 5,
    color: '#ec4899',
    featured: true,
    stats: [
      { value: '5', label: 'Screens Designed' },
      { value: 'B2B', label: 'Service Company' }
    ]
  },
  {
    id: 3,
    title: 'MKG Mega Foods',
    category: 'Web Application',
    role: 'Full Stack Developer',
    description: 'E-commerce website for a food business featuring product listings, cart system, order management, and an admin dashboard for inventory and order handling.',
    tech: ['PHP', 'Laravel', 'MySQL'],
    metric: 'Full Stack',
    folder: 'mkg-mega-foods',
    imageCount: 8,
    color: '#f59e0b',
    featured: true,
    stats: [
      { value: 'Admin', label: 'Dashboard Included' },
      { value: 'Laravel', label: 'Backend' }
    ]
  },
  {
    id: 4,
    title: 'Food Delivery Application',
    category: 'Mobile App',
    role: 'Full Stack Developer',
    description: 'Mobile application that allows users to browse restaurants, place food orders, and track delivery. Includes customer interface and backend services for order management.',
    tech: ['React Native', 'Node.js', 'MongoDB'],
    metric: 'Mobile App',
    folder: 'food-delivery-application',
    imageCount: 12,
    color: '#10b981',
    featured: true,
    stats: [
      { value: '12', label: 'App Screens' },
      { value: 'Live', label: 'Order Tracking' }
    ]
  },
  {
    id: 6,
    title: 'LesGo',
    category: 'UI/UX & Product Design',
    role: 'UI/UX Designer',
    description: 'Travel community platform concept designed to help users discover and plan trips. Focused on community interaction, trip sharing, and travel inspiration.',
    tech: ['Figma', 'React', 'Firebase'],
    metric: 'UX Design',
    folder: 'les-go',
    imageCount: 7,
    color: '#f97316',
    featured: true,
    stats: [
      { value: '7', label: 'Screens Designed' },
      { value: 'Figma', label: 'Prototyped' }
    ]
  },
  {
    id: 7,
    title: 'Health Heaven',
    category: 'Gym & Fitness Platform',
    role: 'Full Stack Developer',
    description: 'Fitness platform designed for gym members and trainers. Includes workout tracking, trainer booking, and fitness management features with a modern dashboard interface.',
    tech: ['React', 'Node.js', 'MongoDB'],
    metric: 'Delivered',
    folder: 'health-heaven',
    imageCount: 5,
    color: '#ec4899',
    stats: [
      { value: 'Member', label: 'Portal Included' },
      { value: 'Trainer', label: 'Booking System' }
    ]
  },
  {
    id: 8,
    title: 'Fyndcareers',
    category: 'Web Application',
    role: 'Developer & Designer',
    description: 'Job and career platform designed to help students and professionals discover opportunities and apply easily. Features company profiles, job listings, and application tracking.',
    tech: ['React', 'Node.js', 'MySQL'],
    metric: 'Delivered',
    folder: 'fyndcareers',
    imageCount: 8,
    color: '#8b5cf6',
    stats: [
      { value: 'Student', label: 'Focused Platform' },
      { value: 'Full', label: 'Application Flow' }
    ]
  },
  {
    id: 9,
    title: 'Spurvo',
    category: 'UI/UX & Product Design',
    role: 'Designer',
    description: 'Productivity and team management tool concept focused on task organization, collaboration, and progress tracking. Designed as a SaaS-style interface with emphasis on usability and workflow clarity.',
    tech: ['Figma', 'Design System', 'Prototyping'],
    metric: 'Concept Design',
    folder: 'spurvo',
    imageCount: 8,
    color: '#06b6d4',
    stats: [
      { value: '8', label: 'Screens Designed' },
      { value: 'SaaS', label: 'UI Concept' }
    ]
  },
  {
    id: 10,
    title: 'Electriverse',
    category: 'E-commerce',
    role: 'Full Stack Developer',
    description: 'E-commerce platform for electrical lighting and decorative products. Includes multi-category product catalog, filtering system, product pages, and admin management features.',
    tech: ['React', 'Node.js', 'MySQL'],
    metric: 'Full Stack',
    folder: 'electriverse',
    imageCount: 6,
    color: '#fbbf24',
    stats: [
      { value: 'Admin', label: 'Panel Included' },
      { value: 'Multi', label: 'Category Catalog' }
    ]
  },
  {
    id: 11,
    title: '3e Solar Ventures',
    category: 'Corporate Website',
    role: 'Designer & Developer',
    description: 'Corporate website for a solar energy company with a solar savings calculator and automated brochure generation. Users receive a PDF report via email after submitting their details.',
    tech: ['React', 'Node.js', 'Figma'],
    metric: 'Delivered',
    folder: '3e-solar-ventures',
    imageCount: 9,
    color: '#fbbf24',
    stats: [
      { value: 'PDF', label: 'Auto Brochure' },
      { value: 'Solar', label: 'Savings Calculator' }
    ]
  },
  {
    id: 13,
    title: 'Pushti Amritulya',
    category: 'UI/UX & Product Design',
    role: 'Designer',
    description: 'Branding and UI design project for an organic products business. Focused on premium visual identity and product presentation.',
    tech: ['Figma', 'UI Design', 'Branding'],
    metric: 'Branding',
    folder: 'pushti-amritulya',
    imageCount: 7,
    color: '#10b981',
    stats: [
      { value: 'Brand', label: 'Identity System' },
      { value: 'UI', label: 'Design Screens' }
    ]
  },
  {
    id: 14,
    title: 'Shri Balaji Cement Product',
    category: 'Corporate Website',
    role: 'Developer',
    description: 'Corporate website for a manufacturing company featuring product listings, company information, and lead generation forms.',
    tech: ['React', 'Node.js', 'MySQL'],
    metric: 'Delivered',
    folder: 'shri-balaji-cement-product',
    imageCount: 4,
    color: '#64748b',
    stats: [
      { value: 'Lead', label: 'Gen Forms' },
      { value: 'Product', label: 'Catalog' }
    ]
  },
  {
    id: 15,
    title: 'Shri Krishna Publications',
    category: 'Corporate Website',
    role: 'Designer & Developer',
    description: 'Digital catalog website for a publishing company showcasing books, authors, and available publications.',
    tech: ['React', 'Firebase'],
    metric: 'Delivered',
    folder: 'shri-krishna-publications',
    imageCount: 5,
    color: '#d97706',
    stats: [
      { value: 'Book', label: 'Catalog' },
      { value: 'Author', label: 'Profiles' }
    ]
  },
  {
    id: 16,
    title: 'Bilans',
    category: 'UI/UX & Product Design',
    role: 'Designer',
    description: 'Event planning and vendor management platform concept that allows users to find vendors and manage event planning activities through a structured dashboard interface.',
    tech: ['Figma', 'UI Design', 'Prototyping'],
    metric: 'Concept Design',
    folder: 'bilans',
    imageCount: 8,
    color: '#3b82f6',
    stats: [
      { value: 'Vendor', label: 'Management' },
      { value: '8', label: 'Screens Designed' }
    ]
  },
  {
    id: 17,
    title: 'Prediction Application',
    category: 'Mobile App',
    role: 'Full Stack Developer',
    description: 'Interactive prediction-based platform where users can make predictions related to sports, concerts, elections, and stocks. Features user participation, result tracking, and leaderboards.',
    tech: ['React Native', 'Node.js', 'MongoDB'],
    metric: 'Delivered',
    folder: 'predcition-application',
    imageCount: 6,
    color: '#8b5cf6',
    stats: [
      { value: 'Multi', label: 'Category Predictions' },
      { value: 'Live', label: 'Result Tracking' }
    ]
  },
  {
    id: 18,
    title: 'Almost Loyal',
    category: 'E-commerce',
    role: 'Developer',
    description: 'Streetwear e-commerce platform built with Next.js. Includes product catalog, product pages, and a full checkout workflow.',
    tech: ['Next.js', 'React', 'Tailwind CSS'],
    metric: 'Delivered',
    folder: 'almost-loyal',
    imageCount: 8,
    color: '#ec4899',
    stats: [
      { value: 'Next.js', label: 'Built With' },
      { value: 'Full', label: 'Checkout Flow' }
    ]
  },
  {
    id: 19,
    title: 'FR Solutions',
    category: 'Web Application',
    role: 'Developer',
    description: 'Shipping and logistics management platform with role-based dashboards for admin, employees, and customers. Includes shipment tracking and order management features.',
    tech: ['React', 'Node.js', 'MongoDB'],
    metric: 'Role-based Access',
    folder: 'fr-solutions',
    imageCount: 6,
    color: '#06b6d4',
    stats: [
      { value: '3', label: 'User Roles' },
      { value: 'Live', label: 'Shipment Tracking' }
    ]
  },
  {
    id: 20,
    title: 'Urban Interiors',
    category: 'Corporate Website',
    role: 'Designer',
    description: 'Portfolio website for an interior design business showcasing completed projects, service offerings, and design galleries.',
    tech: ['Figma', 'React', 'CSS3'],
    metric: 'Delivered',
    folder: 'urban-interiors',
    imageCount: 8,
    color: '#f59e0b',
    stats: [
      { value: 'Project', label: 'Gallery' },
      { value: 'Service', label: 'Showcase' }
    ]
  }
];

// Helper function to get images for a project
export const getProjectImages = (projectFolder, imageCount) => {
  const images = [];
  for (let i = 1; i <= imageCount; i++) {
    // Determine extension based on folder
    const ext = projectFolder === 'plant-identification-app' ? 'jpeg' : 'png';
    images.push(`/assets/${projectFolder}/page-${i}.${ext}`);
  }
  return images;
};

// Helper function to get featured projects only
export const getFeaturedProjects = () => {
  return projectsConfig.filter(project => project.featured);
};

// Helper function to get all projects
export const getAllProjects = () => {
  return projectsConfig;
};

// Helper function to get project by id
export const getProjectById = (id) => {
  return projectsConfig.find(project => project.id === id);
};

export default projectsConfig;
